module.exports = __webpack_public_path__ + "static/img/48-1.79d0744.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/48-1.jpg
// module id = JQOf
// module chunks = 0